<template>
  <div :class="$style.container">
    <div
      v-show="!isLoading"
      data-test-id="BrowserPatchManagementMainPanel__container"
    >
      <BrowserPatchManagementItemTable
        ref="itemTable"
        :class="$style.itemTableContainer"
        :gettingStartedItemType="gettingStartedPanelItemType"
        :itemType="itemType"
        :useDropDownFilterComponent="dropdownFilter"
        :viewport="viewport"
        @loaded="onLoaded"
      />
    </div>
    <LoadingOverlay
      :showLoadingOverlay="isLoading"
    />
  </div>
</template>

<script>
import { FilterComponentConsts } from 'client/util/Constants';
import { timeoutFunction } from 'client/util/timeoutUtils';
import BrowserPatchManagementItemTable from 'client/BrowserManagement/BrowserPatchManagementItemTable';
import LoadingOverlay from 'components/LoadingOverlay/LoadingOverlay';
import MainPanelMixin from 'components/MainPanel/mixins/MainPanelMixin';

export default {
  name: 'BrowserPatchManagementMainPanel',

  components: {
    BrowserPatchManagementItemTable,
    LoadingOverlay,
  },

  mixins: [MainPanelMixin],

  data: () => ({
    FilterComponentConsts,
    isLoading: true,
  }),

  computed: {
    dropdownFilter() {
      return FilterComponentConsts.BrowserPolicyDropDownFilter;
    },
  },

  methods: {
    onLoaded() {
      // The timeout is used here in order to get some delay time for the spinner to dissappea
      // Same case that OsPatchManagementMainPanel.vue
      timeoutFunction(() => {
        this.isLoading = false;
      }, 300);
    },
  },
};
</script>

<style module>
.container {
  background: var(--jcWhite300);
  position: relative;
}

.itemTableContainer {
  height: 100vh;
}
</style>
